import React, { useState, useEffect } from 'react';
import { useTranslate, useDataProvider, usePermissions, Loading } from 'react-admin';
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Box, Dialog, DialogContent, Typography, ListItem, Grid, Button, CircularProgress, Card, FormControlLabel, FormControl, RadioGroup, IconButton, InputBase, Radio } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import Checkbox from '../checkbox'
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import { Close, Search } from '@material-ui/icons'
import ic_attachment from '../assets/icons/ic_attachment.png'
import ic_delete from '../assets/icons/primary-blue-bin.png'
import moment from 'moment-timezone';
import colors from '../CustomizedUIs/Colors'
import DialogChooseFile from '../file-management/file-management-dialog'
import StartCalendar from '../common/DatePicker/startCalendar'
import StopCalenrar from '../common/DatePicker/stopCalendar'
import CustomMessagePoper from '../message/custom-message-popover';
import { intervalToDuration } from 'date-fns/esm';
import TimePicker from '../common/TimePicker'
import { useDispatch } from 'react-redux';
import { isBlockingInfoChannel } from '../infochannels/action';
import { isVideo } from "../utils";
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    dialogPaper: {

        minHeight: '80vh',
        maxHeight: '80vh',
        backgroundColor: theme.palette.background.default
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    btnClose: {
        width: '25px',
        height: '25px',
        border: 'solid 2px #e5f1f8',
        backgroundColor: '#ffffff',
        padding: 0
    },
    textClose: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.4px',
        color: '#4f5064',
    },
    titleRoom: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: " #4f5064",
    },
    TitleDateTime: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    TitleTime: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#88898c',
    }, Time: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    titleRadio: {
        fontFamily: "UniviaPro-Medium",
        fontSize: "11px",
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        color: "4f5064",
    },
    textSearch: {
        fontFamily: "UniviaPro-Book",
        fontSize: "11px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        '&::placeholder': {
            color: '#88898c',
            opacity: 1
        }
    },
}))


const plays = ['One time', 'Always', 'At intervals', 'Daily', 'Weekdays', 'Weekly', 'Monthly']
const intervals = new Array(5, 10, 15, 20, 30, 45, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360)


const FilterInput = ({ onChangeValue, value, name }) => {
    const classes = useStyles();
    const theme = useTheme()
    return (

        <Box width={200} display='flex' style={{ borderRadius: '8.1px', border: ' solid 0.8px #f1f2f4', backgroundColor: "#f7f7f7" }} >
            <Search style={{ color: '#b4b5bd', size: '18px', margin: 'auto 2px auto 5px' }} />
            <InputBase
                className={classes.textSearch}
                value={value}
                onChange={onChangeValue}
                placeholder={name}
                inputProps={{
                    'aria-label': 'search',
                }}
                style={{ width: '180px' }}
            />
        </Box>
    )
}


const EditClusterDialog = ({ open, handleClose, data, ...props }) => {
    const classes = useStyles();
    const dataProvider = useDataProvider()
    const { permissions, loaded } = usePermissions();
    const [openPlay, setOpenPlay] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false)
    const [valueStartTime, setValueStartTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [dateStart, setDateStart] = useState(new Date());
    const [minDateStart, setMinDateStart] = useState(null);
    const date = new Date();
    date.setHours(23, 59, 59);
    const [valueStopTime, setValueStopTime] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [dateStop, setDateStop] = useState(date);
    const [timeStart, setTimeStart] = useState()
    const [timeStartValue, setStartTimeValue] = useState(data.startTime)
    const [timeStop, setTimeStop] = useState()
    const [timeStopValue, setStopTimeValue] = useState(data.stopTime)
    const [oldDateStop, setOldDateStop] = useState(date);
    const [oldDateStart, setOldDateStart] = useState(new Date());
    const [anchorElStopCalendar, setAnchorElStopCalendar] = React.useState(null);
    const [anchorElStartCalendar, setAnchorElStartCalendar] = React.useState(null);
    const [noEndDate, setNoEndDate] = useState(false)
    const translate = useTranslate();
    const [image, setImage] = useState();
    const [openImage, setOpenImage] = useState(false);
    const [sound, setSound] = useState('');
    const [soundValue, setSoundValue] = useState()
    const [openSound, setOpenSound] = useState();
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [standbyMode, setStandbyMode] = useState({
        force: false,
        standby: false
    });
    const [play, setPlay] = useState(data.typeName)
    const [radioChannel, setRadioChannel] = useState()
    const [openRadio, setOpenRadio] = useState(false)
    const [radioChannels, setRadiosChannels] = useState([])
    const [openInterval, setOpenInterval] = useState(false)
    const [interval, setIntervalValue] = useState(intervals[0])
    const [filterRadioChannel, setFilterRadioChannel] = useState('')
    const [openTimePickerStart, setOpenTimePickerStart] = useState(false)
    const [openTimePickerStop, setOpenTimePickerStop] = useState(false)
    const [pickFile, setPickFile] = useState()
    const dispatch = useDispatch();
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        setResponse: null
    })
    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 7,
            setResponse: setPickFile
        })
    }

    const handleCloseFileDialog = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            setResponse: null
        })
    }

    const onChangeFilterRadioChannel = (event) => {
        setFilterRadioChannel(event.target.value)
    }


    const handleClickRadio = () => {
        setOpenRadio(!openRadio)
    }

    const handlePickRadio = (value) => {
        setRadioChannel(value)
        setOpenRadio(false)
    }

    const handleClickInterval = () => {
        setOpenInterval(!openInterval)
    }

    const handlePickInterval = (value) => {
        setIntervalValue(value)
        setOpenInterval(false)
    }

    //-----handleRadioButton----
    const onChangeCheckBox = (event, name) => {
        setStandbyMode({ ...standbyMode, [name]: event.target.checked });
    };
    //-----openPoper---
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    //-----Inherit--------
    const handleClickOpenPlay = () => {
        setOpenPlay(!openPlay)
    }

    const onChangePlay = (value) => {
        setPlay(value)
        setOpenPlay(false)
    }
    useEffect(() => {
        if (play === 'One time') {
            setDateStop(dateStart)
            setValueStopTime(valueStartTime)
        }
    }, [play])

    ///-------Image-------

    const handleClickOpenImage = () => {
        setOpenImage(!openImage)
    }

    const onChangeImage = (value) => {

        setImage(value)
        setOpenImage(false)
    }
    //-------Sound--------
    const handleClickOpenSound = () => {
        setOpenSound(!openSound)
    }

    const onChangeSound = (value) => {
        if (value === 'None') {
            setSound('')
        }
        else {
            setSound(value)
        }
        setOpenSound(false)
    }

    //-----Calendar-------
    const handleClickStopCalendar = (event) => {
        if (anchorElStopCalendar == null)
            setAnchorElStopCalendar(event.currentTarget)
        else {
            handleCloseStopCalendar()
            setAnchorElStopCalendar(null)
        }

    };

    const handleCloseStopCalendar = () => {
        setDateStop(oldDateStop)
        setAnchorElStopCalendar(null);
        setNoEndDate(valueStopTime == translate(`resources.room.onGoing`))
    };


    const onChangNoEndDate = (e) => {
        setNoEndDate(e.target.checked)
        setValueStopTime(e.target.checked ? translate(`resources.room.onGoing`) : moment(dateStop).format('YYYY-MM-DD'))
        setOldDateStop(dateStop)
        setAnchorElStopCalendar(null);

    }

    // const finishPickDateStop = () => {
    //     setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(dateStop).format('YYYY-MM-DD'))
    //     setOldDateStop(dateStop)
    //     setStopTimeValue(moment(timeStop).format('HH:mm'))
    //     if (timeStop.getTime() < timeStart.getTime()) {
    //         setTimeStart(timeStop)
    //         setStartTimeValue((moment(timeStop).format('HH:mm')))
    //     }
    //     setAnchorElStopCalendar(null);
    // };

    const onChangeStopCalendar = (date) => {
        setDateStop(date)
        setValueStopTime(noEndDate ? translate(`resources.room.onGoing`) : moment(date).format('YYYY-MM-DD'))
        setOldDateStop(date)
        setStopTimeValue(moment(timeStop).format('HH:mm'))
        if (timeStop.getTime() < timeStart.getTime()) {
            setTimeStart(timeStop)
            setStartTimeValue((moment(timeStop).format('HH:mm')))
        }
        setAnchorElStopCalendar(null);
        setOpenTimePickerStart(false)
    }
    //----------------------
    //event select of Start Calendar

    const handleClickStartCalendar = (event) => {
        if (anchorElStartCalendar == null)
            setAnchorElStartCalendar(event.currentTarget)
        else {
            handleCloseStartCalendar()
            setAnchorElStartCalendar(null)
        }

    };

    const handleCloseStartCalendar = () => {
        setDateStart(oldDateStart)
        setAnchorElStartCalendar(null);
    };

    // const finishPickDate = () => {
    //     setValueStartTime(moment(dateStart).format('YYYY-MM-DD'))
    //     if (dateStart > dateStop && valueStopTime != translate(`resources.room.onGoing`)) {
    //         setDateStop(dateStart)
    //         setValueStopTime((moment(dateStart).format('YYYY-MM-DD')))
    //     }
    //     setStartTimeValue(moment(timeStart).format('HH:mm'))
    //     if (timeStart.getTime() > timeStop.getTime()) {
    //         setTimeStop(timeStart)
    //         setStopTimeValue((moment(timeStart).format('HH:mm')))
    //     }
    //     setOldDateStart(dateStart)
    //     setAnchorElStartCalendar(null);
    // };

    const onChangeStartCalendar = (date) => {
        setDateStart(date)
        setValueStartTime(moment(date).format('YYYY-MM-DD'))
        if ((date > dateStop && valueStopTime != translate(`resources.room.onGoing`)) || play === 'One time') {
            setDateStop(date)
            setValueStopTime((moment(date).format('YYYY-MM-DD')))
        }
        setOldDateStart(date)
        setAnchorElStartCalendar(null);
        setOpenTimePickerStart(false)
    }
    //----------------------
    const formatTime = (times) => {
        if (!times) {
            return '';
        }

        return moment(times).format('HH:mm');
    };

    const onChangeStartTime = (date) => {
        setTimeStart(date)
        setStartTimeValue(moment(date).format('HH:mm'))
        if (date.getTime() > timeStop.getTime()) {
            setTimeStop(date)
            setStopTimeValue((moment(date).format('HH:mm')))
        }
        setOldDateStart(date)
        setAnchorElStartCalendar(null);
        setOpenTimePickerStart(false)

    }

    const onChangeStopTime = (date) => {
        setTimeStop(date)
        setOldDateStop(date)
        setStopTimeValue(moment(date).format('HH:mm'))
        if (date.getTime() < timeStart.getTime()) {
            setTimeStart(date)
            setStartTimeValue((moment(date).format('HH:mm')))
        }
        setAnchorElStopCalendar(null);
        setOpenTimePickerStart(false)
        setOpenTimePickerStart(false)
    }

    const pickSound = (event) => {
        setSoundValue(event.target.files[0])
        event.target.value = null
    }

    useEffect(() => {
        pickFile &&
            setSoundValue(pickFile)
    }, [pickFile])

    const getRadioChannel = (id) => {
        setLoadingPage(true)
        dataProvider('GET_LIST', "channel", {
            filter: {
                type: 'Radio'
            },
            sort: { field: 'name', order: 'ASC' },
            pagination: {
                page: 1,
                perPage: -1
            }
        }).then(({ data, total }) => {

            setRadiosChannels(data)
            if (data && data.length > 0) {
                if (!id)
                    setRadioChannel(data[0])
                else
                    setRadioChannel(data.find(item => item.id === id))
            }
            setLoadingPage(false)
        }).catch(error => {
            setLoadingPage(false)
        });

    }

    const onSave = () => {
        dispatch(isBlockingInfoChannel(true))
        var tempsData = [...props.arrayData]

        tempsData[props.index] = {
            ...data,
            typeName: play,
            startDate: new Date(dateStart.setHours(parseInt(timeStartValue.split(':')[0]), parseInt(timeStartValue.split(':')[1]), 0)).getTime(),
            stopDate: new Date(dateStop.setHours(parseInt(timeStopValue.split(':')[0]), parseInt(timeStopValue.split(':')[1]), 0)).getTime(),
            startTime: timeStartValue,
            stopTime: timeStopValue,
            standbyByAfter: standbyMode.standby,
            forceToShow: standbyMode.force,
            noEndDate: noEndDate
        }
        // if (image !== 12) {
        //     tempsData[props.index].fileOfSchedule.map(item => {
        //         if (item.imageShowTime === 12)
        //             item.imageShowTime = image
        //         return item
        //     })
        // }
        if (data.defaultShowTime !== image) {
            tempsData[props.index].defaultShowTime = image
            tempsData[props.index].fileOfSchedule.map(item => {
                if (!isVideo(item.type))
                    item.imageShowTime = image
                return item
            })
        }
        if (play === 'At intervals')
            tempsData[props.index].interval = interval
        if (sound === 'From file' && soundValue)
            tempsData[props.index].sound = { type: 'From file', id: soundValue.id }
        else if (sound === 'Radio' && radioChannel)
            tempsData[props.index].sound = { type: 'Radio', id: radioChannel.id }
        else tempsData[props.index].sound = ""
        props.setData(tempsData)
        handleClose()
    }

    const getFileInfo = (id) => {
        dataProvider('GET_ONE', 'categories', {
            id: id
        }).then(({ data }) => {
            setSoundValue(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    useEffect(() => {
        if (open) {
            setPlay(data.typeName)
            setTimeStart(new Date(`01/01/1970 ${data.startTime}`))
            setTimeStop(new Date(`01/01/1970 ${data.stopTime}`))
            if (data.startTime && data.stopTime) {
                setStartTimeValue(data.startTime)
                setStopTimeValue(data.stopTime)
            }
            setImage(data.defaultShowTime)
            setDateStart(new Date(data.startDate))
            setMinDateStart(data.startDate ? new Date(data.startDate) : new Date());
            setDateStop(new Date(data.stopDate))
            setOldDateStart(new Date(data.startDate))
            setOldDateStop(new Date(data.stopDate))
            setValueStartTime(moment(data.startDate).format('YYYY-MM-DD'))
            setNoEndDate(data.noEndDate)
            setValueStopTime(data.noEndDate ? translate(`resources.room.onGoing`) : moment(data.stopDate).format('YYYY-MM-DD'))
            setStandbyMode({
                standby: data.standbyByAfter,
                force: data.forceToShow
            })
            //getRadioChannel()
            if (typeof (data.sound) === 'string') {
                setSound('')
                getRadioChannel()
            }
            else {
                setSound(data.sound.type)
                if (data.sound.type === 'Radio')
                    getRadioChannel(data.sound.id)
                else {
                    getFileInfo(data.sound.id)
                    getRadioChannel()
                }
            }
        }
    }, [open])


    if (!loaded) return null
    return (
        <Dialog open={open} scroll='paper' classes={{ paper: classes.dialogPaper }}>
            <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                <Typography style={{ margin: 'auto 8px auto 0' }} className={classes.textClose}>  {translate(`pos.dashboard.close`)}</Typography>
                <CloseButton onClick={handleClose} />
            </Box>
            <Box mb={2} ml={3}>
                <Typography className={classes.titleRoom} style={{ paddingBottom: 8 }}>{translate(`pos.channels.editSchedule`)}</Typography>
            </Box>
            <DialogContent>
                {
                    loadingPage ?
                        <Box pt={1} pb={0} mt={1} style={{ width: 500 }} >
                            <Loading />
                        </Box>
                        :
                        (
                            <Box>
                                <Box pt={1} pb={0} mt={1} style={{ width: 500 }} >
                                    <SelectBox

                                        label={'Play'}
                                        value={<Typography className={classes.TexTSelect} >{play}</Typography>}
                                        open={openPlay}
                                        handleClick={handleClickOpenPlay}
                                    >
                                        <Box className={classes.boxBoder} >
                                            {plays.map((value, i) => (
                                                <ListItem key={'play-' + i} style={{ padding: '14px' }} button onClick={() => onChangePlay(value)}>
                                                    <Typography className={classes.TexTSelect} >{value}</Typography>
                                                </ListItem>
                                            ))}

                                        </Box>
                                    </SelectBox>
                                </Box>
                                {
                                    play !== 'Always' && (
                                        <Box display='flex'
                                            justifyItems='center'
                                            py={2} my={1}
                                            bgcolor={colors.white['50']}
                                            border={1}
                                            borderColor={colors.lightBlue['200']}
                                            borderRadius='4px' >
                                            <Box mx='auto' width='469px' >
                                                <Typography style={{ paddingBottom: 8 }} className={classes.TitleDateTime}>{translate(`pos.infochannel.date`)}</Typography>
                                                <Grid container justify="space-between" alignItems="flex-end">
                                                    <Grid item style={{ width: '207px' }}>
                                                        <StartCalendar
                                                            Title={translate(`pos.infochannel.start`)}
                                                            anchorEl={anchorElStartCalendar}
                                                            handleClick={handleClickStartCalendar}
                                                            handleClose={handleClickStartCalendar}
                                                            handleDateChange={onChangeStartCalendar}
                                                            value={valueStartTime}
                                                            minDate={new Date()}
                                                            date={dateStart}

                                                        // time={timeStart}
                                                        // handleTimeChange={onChangeStartTime}
                                                        // finishPickDate={finishPickDate}
                                                        />
                                                    </Grid>
                                                    <Grid item style={{ width: '207px' }}>
                                                        <StopCalenrar
                                                            Title={translate(`pos.infochannel.stop`)}
                                                            isNoEndDate={noEndDate}
                                                            onChangNoEndDate={onChangNoEndDate}
                                                            minDate={dateStart}
                                                            anchorEl={anchorElStopCalendar}
                                                            play={play}
                                                            handleClick={handleClickStopCalendar}
                                                            handleClose={handleClickStopCalendar}
                                                            handleDateChange={onChangeStopCalendar}
                                                            value={valueStopTime}
                                                            date={dateStop}
                                                            hideNoEndDate
                                                        // time={timeStop}
                                                        // handleTimeChange={onChangeStopTime}
                                                        // finishPickDate={finishPickDateStop}
                                                        />
                                                    </Grid>
                                                </Grid>{

                                                }
                                                <Box style={{ marginTop: "1em", borderRadius: '0', width: '207px', height: '36px' }} bgcolor='white' >
                                                    <FormControlLabel
                                                        control={<Box alignItems="center" ml={2} display="flex">
                                                            <Typography onClick={() => setOpenTimePickerStart(true)} className={classes.Time} >{timeStartValue}</Typography>
                                                            <Typography className={classes.Time} >-</Typography>
                                                            <Typography onClick={() => setOpenTimePickerStop(true)} className={classes.Time} >{timeStopValue}</Typography>
                                                        </Box>}
                                                        label={<Typography className={classes.TitleTime}>{translate(`pos.messages.time`)}</Typography>}
                                                        style={{ marginTop: "8px", color: "#88898c" }}
                                                        labelPlacement="start"
                                                    />
                                                    <TimePicker
                                                        openTimePicker={openTimePickerStart}
                                                        handleClick={handleClickStartCalendar}
                                                        setOpenTimePicker={setOpenTimePickerStart}
                                                        // handleDateChange={onChangeStartCalendar}
                                                        handleTimeChange={onChangeStartTime}
                                                        // finishPickDate={finishPickDate}
                                                        time={timeStart}
                                                        value={timeStartValue}
                                                        // date={timeStartValue}
                                                        hours
                                                    />
                                                    <TimePicker
                                                        openTimePicker={openTimePickerStop}
                                                        minDate={valueStartTime}
                                                        handleClick={handleClickStopCalendar}
                                                        setOpenTimePicker={setOpenTimePickerStop}
                                                        // handleDateChange={onChangeStopCalendar}
                                                        handleTimeChange={onChangeStopTime}
                                                        // finishPickDate={finishPickDateStop}
                                                        value={timeStopValue}
                                                        time={timeStop}
                                                        // date={dateStop}
                                                        hours

                                                    />
                                                </Box>
                                                {
                                                    play === 'At intervals' && (
                                                        <Box pt={1} pb={0} mt={1} >
                                                            <SelectBox

                                                                label={translate(`pos.channels.intervalsOf`)}
                                                                value={<Typography className={classes.TexTSelect} >{interval + translate(`pos.channels.minutes`)}</Typography>}
                                                                open={openInterval}
                                                                handleClick={handleClickInterval}
                                                            >
                                                                <Box className={classes.boxBoder} >
                                                                    {
                                                                        intervals.map((value, index) => (
                                                                            <ListItem style={{ padding: '8px' }} button onClick={() => handlePickInterval(value)} key={'interval-' + index}>
                                                                                <Typography className={classes.TexTSelect} >{value + translate(`pos.channels.minutes`)}</Typography>
                                                                            </ListItem>
                                                                        ))
                                                                    }

                                                                </Box>
                                                            </SelectBox>
                                                        </Box>
                                                    )
                                                }

                                            </Box>

                                        </Box>
                                    )
                                }

                                <Box pt={1} pb={0} mt={1} >
                                    <SelectBox

                                        label={translate(`pos.infochannel.Imageshowtime`)}
                                        value={<Typography className={classes.TexTSelect} >{image === 12 ? translate(`pos.channels.default`) : image + translate(`pos.channels.sec`)}</Typography>}
                                        open={openImage}
                                        handleClick={handleClickOpenImage}
                                    >
                                        <Box className={classes.boxBoder} >
                                            {
                                                Array.from({ length: 60 }, (value, index) => (
                                                    <ListItem style={{ padding: '14px' }} button onClick={() => onChangeImage(index + 1)} key={index}>
                                                        <Typography className={classes.TexTSelect} >{index + 1 + translate(`pos.channels.sec`)}</Typography>
                                                    </ListItem>
                                                ))
                                            }

                                        </Box>
                                    </SelectBox>
                                </Box>
                                <Box pt={1} pb={0} mt={1}  >
                                    <SelectBox
                                        label={translate(`pos.infochannel.Sound`)}
                                        value={sound}
                                        open={openSound}
                                        handleClick={handleClickOpenSound}
                                    >
                                        <Box className={classes.boxBoder} >
                                            <ListItem style={{ padding: '14px' }} button onClick={() => onChangeSound('None')}>
                                                <Typography className={classes.TexTSelect} >{translate(`pos.common.none`)}</Typography>
                                            </ListItem>
                                            <ListItem style={{ padding: '14px' }} button onClick={() => onChangeSound('From file')}>
                                                <Typography className={classes.TexTSelect} >{translate(`pos.channels.fromFile`)}</Typography>
                                            </ListItem>
                                            <ListItem style={{ padding: '14px' }} button onClick={() => onChangeSound('Radio')}>
                                                <Typography className={classes.TexTSelect} >{translate(`pos.channels.radioChannel`)}</Typography>
                                            </ListItem>
                                        </Box>
                                    </SelectBox>
                                </Box>
                                {
                                    sound === '' ? null :
                                        sound === 'From file' ?
                                            (
                                                <Box display='flex'
                                                    justifyItems='center'
                                                    pt={1} pb={2} my={1}
                                                    bgcolor={colors.white['50']}
                                                    border={1}
                                                    borderColor={colors.lightBlue['200']}
                                                    borderRadius='4px' >
                                                    <Box width={469} m='auto'>
                                                        <Typography style={{ fontFamily: 'UniviaPro-Medium', fontSize: '11px', lineHeight: '13.2px', letterSpacing: '0.36px', fontStretch: 'normal', fontStyle: 'normal', fontWeight: 500, marginBottom: 8 }}>{translate(`pos.channels.addSound`)}</Typography>
                                                        <Box display='flex' py={1} px={2} bgcolor='white' border={1} borderColor='#c1e5fa' borderRadius={4}>
                                                            <Box display='flex' flexGrow={1} alignItems='center'>
                                                                <img src={ic_attachment} width={27} height={27} style={{ marginRight: 8 }}></img>
                                                                <Typography style={{ fontFamily: 'UniviaPro-Medium', fontSize: '11px', lineHeight: '13.2px', letterSpacing: '0.36px', fontStretch: 'normal', fontStyle: 'normal', fontWeight: 500, marginRight: 8 }} >{translate(`pos.infochannel.Sound`)}</Typography>
                                                                <CustomMessagePoper
                                                                    open={openPoper}
                                                                    anchorEl={anchorEl}
                                                                    handleClick={handleClickOpenPoper}
                                                                    handleClose={handleClosePoper}
                                                                    title={translate(`pos.common.sound`)}
                                                                    content={translate(`pos.common.contentSound`)}
                                                                    icon={<b>?</b>}
                                                                />
                                                            </Box>
                                                            <Button style={{ fontFamily: 'UniviaPro-Bold', fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontStretch: 'normal', fontStyle: 'normal', fontWeight: 'bold' }} variant='contained' color='primary' onClick={handleOpenFileDialog}>
                                                                {
                                                                    soundValue ? translate(`pos.channels.change`) : translate(`pos.channels.browse`)
                                                                }

                                                            </Button>
                                                            <DialogChooseFile
                                                                defaultId={openFile.defaultId}
                                                                open={openFile.status}
                                                                pickerMode='pickMediaOnly'
                                                                handleClose={handleCloseFileDialog}
                                                                setChooseValue={openFile.setResponse}
                                                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                                                            />

                                                        </Box>
                                                        {
                                                            soundValue && (
                                                                <Box display='flex' py={2} boxShadow='0 3px 6px 0 rgba(27, 102, 157, 0.04)' px={2} my={1} bgcolor='white'>
                                                                    <Box display='flex' flexGrow={1} alignItems='center'>
                                                                        <Typography style={{
                                                                            fontFamily: 'UniviaPro', fontSize: '13px', fontWeight: 'normal', fontStyle: 'normal',
                                                                            fontStretch: 'normal ', lineHeight: '16.3px', letterSpacing: '0.13px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#4f5064'
                                                                        }}>
                                                                            {soundValue.name}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box display='flex' alignItems='center'>
                                                                        <Typography style={{
                                                                            fontFamily: 'UniviaPro-Medium', fontSize: '11px', fontWeight: 500, fontStyle: 'normal',
                                                                            fontStretch: 'normal ', lineHeight: '16.3px', letterSpacing: '0.13px', maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#88898c'
                                                                        }}>{soundValue.size % 1024 >= 5 ? (parseInt(soundValue.size / 1024, 10) + 1 + translate(`pos.common.kb`)) : (parseInt(soundValue.size / 1024, 10) + translate(`pos.common.kb`))}</Typography>
                                                                        <IconButton
                                                                            onClick={() => { setSoundValue(null) }}
                                                                            style={{ marginLeft: 34, padding: 0, width: 25, height: 25, borderRadius: 10, border: 'solid 2px #e5f1f8', backgroundColor: 'white' }}>
                                                                            <img src={ic_delete} width={12.2} height={12.2} ></img>
                                                                        </IconButton>

                                                                    </Box>

                                                                </Box>
                                                            )
                                                        }


                                                    </Box>
                                                </Box>
                                            )
                                            :
                                            (
                                                sound !== 'None' &&
                                                <Box pt={1} pb={0} mt={1}  >
                                                    <SelectBox

                                                        label={translate(`pos.channels.radioChannel`)}
                                                        value={!radioChannel ? "" : radioChannel.name}
                                                        open={openRadio}
                                                        handleClick={handleClickRadio}
                                                        filter={(
                                                            <Box style={{ backgroundColor: "#ffffff" }} p={1} className={classes.boxBoder}>
                                                                <FilterInput onChangeValue={onChangeFilterRadioChannel} value={filterRadioChannel} name={translate(`pos.channels.searchRadioChannel`)} />
                                                            </Box>
                                                        )}
                                                    >
                                                        <Box className={classes.boxBoder} >
                                                            {
                                                                radioChannels.filter(element => element.name.toUpperCase().includes(filterRadioChannel.toUpperCase().trim())).map(item => (
                                                                    <ListItem style={{ padding: '14px' }} button onClick={() => handlePickRadio(item)} key={'raidochannel-' + item.id}>
                                                                        <Typography className={classes.TexTSelect} >{item.name}</Typography>
                                                                    </ListItem>
                                                                ))
                                                            }
                                                        </Box>
                                                    </SelectBox>
                                                </Box>
                                            )
                                }

                                {/* <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: ' #e6e6eb' }} />
                                <Box mt={2.5} mx={2.5}>
                                    <FormControl component="fieldset">
                                        <Grid container spacing={1} alignItems="center" >
                                            <Grid item>
                                                <Typography className={classes.titleRadio} color="textPrimary" >{translate(`pos.infochannel.Standbycontrol`)}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <CustomMessagePoper
                                                    open={openPoper}
                                                    anchorEl={anchorEl}
                                                    handleClick={handleClickOpenPoper}
                                                    handleClose={handleClosePoper}
                                                    title={translate(`pos.common.standByControl`)}
                                                    content={translate(`pos.common.contentStandByControl`)}
                                                    icon={<b>?</b>}
                                                />
                                            </Grid>
                                        </Grid>
                                        <RadioGroup row aria-label="position" name="position">
                                            <FormControlLabel value={1} control={<Checkbox checked={standbyMode.force} onChange={(e) => onChangeCheckBox(e, 'force')} />} classes={{ label: classes.titleRadio }} label={translate(`pos.infochannel.force`)} />
                                            <FormControlLabel value={0} control={<Checkbox checked={standbyMode.standby} onChange={(e) => onChangeCheckBox(e, 'standby')} />} classes={{ label: classes.titleRadio }} label={translate(`pos.infochannel.standby`)} style={{ marginLeft: '63px' }} />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>


                                <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: ' #e6e6eb' }} /> */}
                            </Box>

                        )
                }



            </DialogContent>
            <Box display='flex' justifyContent='flex-end' py={2} px={3}>
                <Box display='flex' alignItems='flex-end'>
                    <TextButton style={{ marginRight: '30px' }} onClick={handleClose} />
                    <Button variant="contained" color='primary' size='large'
                        onClick={onSave}
                    >
                        {loading ? (
                            <CircularProgress
                                size={20}
                                thickness={2}
                                color='inherit'
                            />
                        ) : <Typography className={classes.btnCreate}>{translate(`pos.infochannel.save`)}</Typography>}
                    </Button>
                </Box>
            </Box>
        </Dialog >
    )
}
export default EditClusterDialog